// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../../common/JQueryView';
import DateRangePicker from '../../../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
    this.initDateRangePicker(this.$el);
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .parents('.input-group')
      .children('input,.daterange-picker')
      .focus();
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }
}
